import React, { createContext } from 'react'
import data from '@emoji-mart/data'

export const emojiData = data

type EmojiData = typeof emojiData;

export const EmojiContext = createContext<EmojiData>(emojiData);
export const useEmoji = (): EmojiData => React.useContext(EmojiContext)
